<script lang="ts" setup>
import { CirclePlusFilled, UploadFilled } from '@element-plus/icons-vue'

interface IProps {
  wantSave: boolean
  isLoading?: boolean
  page: 'Deduction' | 'AddIncomes'
  hasItems: boolean
}

const props = defineProps<IProps>()
interface IEmits {
  (e: 'add'): void
  (e: 'save'): void
  (e: 'skip'): void
}

const emit = defineEmits<IEmits>()
</script>

<template>
  <el-button-group>
    <el-button :icon="CirclePlusFilled" type="primary" @click="$emit('add')" class="button-main" :loading="isLoading">
      {{ page === 'Deduction' ? 'Добавить вычет' : 'Добавить доход' }}
    </el-button>
    <el-tooltip
      class="item"
      effect="dark"
      :content="page === 'Deduction' ? 'Сохранить вычеты' : 'Сохранить дополнительные доходы'"
      placement="top-start"
      v-if="wantSave"
    >
      <el-button :icon="UploadFilled" type="success" @click="$emit('save')" class="button-main" :loading="isLoading">
        Сохранить
      </el-button>
    </el-tooltip>
  </el-button-group>
</template>

<style lang="sass" scoped></style>
